// src/lib/cardStyle.js
// Helpers puros compartilhados pelo renderer do cartao, pelos blocos e pelos testes.
// SEM React, SEM DOM — mantenha importavel de um teste jest simples.

// ── Fundo de botao/link ─────────────────────────────────────────────
// theme.buttonBg era sempre string hex. Agora tambem aceita um objeto do
// BackgroundPicker: {type:'solid',value} | {type:'gradient',from,to,angle}
// | {type:'preset',value}. resolveCardBg() sempre devolve string CSS de
// `background` (ou '' quando nada esta definido).
function resolveCardBg(value, presets) {
  if (!value) return '';
  if (typeof value === 'string') return value;
  if (value.type === 'solid') return value.value || '';
  if (value.type === 'gradient') {
    const { from, to } = value;
    const angle = value.angle == null ? 135 : value.angle;
    if (!from || !to) return '';
    return `linear-gradient(${angle}deg, ${from}, ${to})`;
  }
  if (value.type === 'preset') {
    const hit = (presets || []).find((p) => p.id === value.value);
    if (!hit || !hit.style) return '';
    return hit.style.background || hit.style.backgroundColor || '';
  }
  return '';
}

function isHexColor(s) {
  return typeof s === 'string' && s.trim().charAt(0) === '#';
}

// ── URL de video ────────────────────────────────────────────────────
function parseVideoUrl(raw) {
  if (!raw || typeof raw !== 'string') return null;
  const url = raw.trim();
  const yt = url.match(
    /(?:youtube\.com\/watch\?(?:[^#]*&)?v=|youtu\.be\/|youtube\.com\/embed\/|youtube-nocookie\.com\/embed\/|youtube\.com\/shorts\/)([A-Za-z0-9_-]{11})/
  );
  if (yt) {
    const id = yt[1];
    return {
      provider: 'youtube',
      id,
      watchUrl: `https://www.youtube.com/watch?v=${id}`,
      embedUrl: `https://www.youtube-nocookie.com/embed/${id}?autoplay=1&rel=0`,
      thumbUrl: `https://i.ytimg.com/vi/${id}/hqdefault.jpg`,
      thumbUrlHi: `https://i.ytimg.com/vi/${id}/maxresdefault.jpg`,
    };
  }
  const vm = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
  if (vm) {
    const id = vm[1];
    return {
      provider: 'vimeo',
      id,
      watchUrl: `https://vimeo.com/${id}`,
      embedUrl: `https://player.vimeo.com/video/${id}?autoplay=1`,
      thumbUrl: '',
      thumbUrlHi: '',
    };
  }
  return null;
}

// ── hex -> rgba (para o veu do hero sobreposto) ─────────────────────
function hexToRgba(hex, alpha) {
  let h = typeof hex === 'string' ? hex.trim().replace(/^#/, '') : '';
  if (h.length === 3) h = h.split('').map((c) => c + c).join('');
  if (!/^[0-9a-fA-F]{6}$/.test(h)) return `rgba(0, 0, 0, ${alpha})`;
  const r = parseInt(h.slice(0, 2), 16);
  const g = parseInt(h.slice(2, 4), 16);
  const b = parseInt(h.slice(4, 6), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}

// ── Pares de tipografia ────────────────────────────────────────────
const FONT_PAIRS = {
  system: { label: 'Sistema', display: null, body: null },
  'serif-editorial': {
    label: 'Serifa Editorial',
    display: "'Instrument Serif', Georgia, 'Times New Roman', serif",
    body: "'DM Sans', system-ui, -apple-system, 'Segoe UI', Roboto, sans-serif",
  },
};

function resolveFontPair(key) {
  return FONT_PAIRS[key] || FONT_PAIRS.system;
}

module.exports = {
  resolveCardBg,
  isHexColor,
  parseVideoUrl,
  hexToRgba,
  FONT_PAIRS,
  resolveFontPair,
};
